<header>
  <img class="logo-image col-md-2" src="assets/home_logo.png" />
  <h3 class="headerTitle col-md-4" style="color:#797878;">&nbsp; Alhambra Control Platform</h3>
  <span fxFlex></span>
  <span class="logoutButton" (click)="logout()">logout</span>
</header>

